import { render, staticRenderFns } from "./internalFundsTransfersList.vue?vue&type=template&id=98ba7af6&scoped=true&"
import script from "./internalFundsTransfersList.vue?vue&type=script&lang=js&"
export * from "./internalFundsTransfersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ba7af6",
  null
  
)

export default component.exports